import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { getSimulationParams } from "../firebase";
import { normalizeWhatsAppPhone, WHATSAPP_PHONE } from "../config/whatsapp";

const ContactSettingsContext = createContext({
  whatsappPhone: WHATSAPP_PHONE,
  setWhatsappPhone: () => {},
  refreshContactSettings: async () => {},
});

export function ContactSettingsProvider({ children }) {
  const [whatsappPhone, setPhone] = useState(WHATSAPP_PHONE);

  const setWhatsappPhone = useCallback((phone) => {
    setPhone(normalizeWhatsAppPhone(phone));
  }, []);

  const refreshContactSettings = useCallback(async () => {
    try {
      const params = await getSimulationParams();
      setWhatsappPhone(params.whatsappPhone);
    } catch (error) {
      console.warn("No se pudo cargar el teléfono de contacto:", error);
    }
  }, [setWhatsappPhone]);

  useEffect(() => {
    refreshContactSettings();
  }, [refreshContactSettings]);

  const value = useMemo(
    () => ({ whatsappPhone, setWhatsappPhone, refreshContactSettings }),
    [whatsappPhone, setWhatsappPhone, refreshContactSettings]
  );

  return (
    <ContactSettingsContext.Provider value={value}>
      {children}
    </ContactSettingsContext.Provider>
  );
}

export const useContactSettings = () => useContext(ContactSettingsContext);
